import { regex } from "./common";

export default regex('numeric', /^([0-9]|([1-9][0-9]*))$/)